import { neutral } from '@bloomfieldrobotics/canopy';
import { Stage } from '../../../../services/entities/impl/blfApi/schemas/stage';
import { getColorForColorLabel } from '../../../commonUI/getColorForColorLabel';

/**
 * Returns the color associated with the given stage.
 *
 * TODO: Discuss where and how to move this to a common location.
 * Potentially create a generic StageLegend that can be used vertically or horizontally
 *
 * @param {Stage} stage - The stage object
 * @returns {string} - The color code corresponding to the stage.
 */
export const getStageColor = (stage: Stage): string => {
  if (stage.displayColor) {
    return getColorForColorLabel(stage.displayColor);
  } else if (stage.className === 'flower') {
    if (stage.subClasses) {
      switch (stage.subClasses.at(0)) {
        case 'closed':
          return '#555';
        case 'open':
          return '#8D8D8D';
        case 'petalfall':
          return '#FFF';
        default:
          return neutral[650];
      }
    }

    return neutral[650];
  }
  return neutral[650];
};
